<template>
    <div>
        <h5>退款信息</h5>
        <div class="card" v-for="(item, index) in refundData " :key="index">
            <el-form-item label="退款项目名称">
                <el-select disabled clearable v-model="item.refundProjectId">
                    <el-option v-for="(item) in newData" :key="item.id" :label="item.project" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="退款补充">
                <el-input @input="testSX" clearable v-model="item.refundReplenish" placeholder="请输入划扣补充"></el-input>
            </el-form-item>
            <el-form-item label="退款金额">
                <div class="little">
                    <el-input disabled clearable v-model="item.refundAmt" placeholder="请输入当日划扣金额" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                </div>
            </el-form-item>
            <span class="alone little">
                <el-form-item label="退款次数" :prop="'refundInformationList.' + index + '.refundContent'" :rules="rules.refundContent" :hide-required-asterisk="true">
                    <el-input @input="tabInput($event,index)" clearable v-model="item.refundContent" placeholder="请输入划扣次数" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                </el-form-item>
            </span>
            <span :class="item.musClass">
                <el-form-item label="退款卡号">
                    <el-input @input="testSX" oninput="value=value.replace(/[^0-9.]/g, '')" clearable v-model="item.refundCode" placeholder="请输入划扣卡号" @change="cardChange($event,index)" @blur="cardBlur($event,index)"></el-input>
                    <div class="cardNum" v-if="item.flag">划扣卡号不存在!</div>
                    <span style="display:none;">{{item.refundCodeTrue}}</span>
                </el-form-item>
            </span>
            <!-- <el-form-item label="剩余次数">
                <span class="little">
                    <el-input disabled clearable v-model="item.refundCount" placeholder="请输入剩余次数" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                </span>
            </el-form-item> -->
            <el-form-item label="备注">
                <el-input @input="testSX" clearable v-model="item.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-button size="mini" type="danger" @click.prevent="del(item,index)">
                <i class="el-icon-delete"></i>
            </el-button>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { log } from 'util';
export default {
    computed: {
        ...mapState(['statusOptions', 'floorOptions', 'areaOptions']),
        ...mapGetters(['list1', 'list2', 'list4', 'productOptions', 'materiaOption']),
    },
    props: ['refundData', 'rowId'],
    data() {
        var checkMus = (rule, value, callback) => {
            if (value) {
                if (isNaN(value) == true) {
                    if (value != '包年') {
                        if (value != '包月') {
                            callback(new Error('划扣次数格式不正确!'));
                        } else {
                            callback();
                        }
                    } else {
                        callback();
                    }
                } else if (isNaN(value) == false) {
                    callback();
                }
            }
            callback();
        };
        return {
            newData: [],
            rules: {
                refundContent: [
                    { required: true, validator: checkMus, trigger: 'blur', }
                ],
            },
            copyData: {}
        }
    },
    created() {
        this.newData = this.$store.getters.productOptions;
        busPhone.$on('tableId', val => { // 接收值
            let index = this.refundData.findIndex(item => item.purchaseId === val)
            if (index != -1) {
                this.refundData.splice(index, 1);
            }
        })
    },
    watch: {
        refundData: {
            handler(newValue, oldValue) {
                // console.log(newValue);
                if (newValue) {
                    newValue.forEach(ele => {
                        if (ele.refundCodeTrue == 1) {
                            ele.flag = true
                            ele.musClass = 'refundCode'
                        } else if (ele.refundCodeTrue == 0) {
                            ele.flag = false
                            ele.musClass = ''
                        }
                        // // 当日划扣金额
                        if (parseInt(ele.residueNumber) - parseInt(ele.refundContent) < 0) {
                            ele.refundContent = 1
                            // 退款次数
                            ele.refundCount = parseInt(ele.residueNumber) - parseInt(ele.refundContent)
                            // console.log('ele.refundCount');
                            // console.log(ele.refundCount);
                            // 当日划扣金额
                            if (ele.residueNumber == ele.refundContent && ele.amt) {
                                ele.refundAmt = (ele.projectAmt - ele.amt).toFixed(2)
                            } else {
                                ele.refundAmt = (ele.unitPrice * ele.refundContent).toFixed(2)
                            }
                            _g.toast('warning', '该产品已无退款次数')
                            return;
                        } else if (parseInt(ele.residueNumber) - parseInt(ele.refundContent) >= 0) {
                            // 退款次数
                            ele.refundCount = parseInt(ele.residueNumber) - parseInt(ele.refundContent)
                            // 当日划扣金额
                            if (ele.residueNumber == ele.refundContent && ele.amt) {
                                ele.refundAmt = (ele.projectAmt - ele.amt).toFixed(2)
                            } else {
                                ele.refundAmt = (ele.unitPrice * ele.refundContent).toFixed(2)
                            }
                        }
                        // console.log('ele.refundCount');
                        // console.log(ele.refundCount);
                    });
                }
            },
            immediate: true,
            deep: true,

        }
    },
    methods: {
        tabInput(val, index) {
            this.$forceUpdate()
            // console.log(val);
            this.refundData.forEach(ele => {
                if (val && val == 0) {
                    ele.refundContent = 1
                    // 剩余次数
                    ele.refundCount = parseInt(ele.residueNumber) - parseInt(ele.refundContent)
                    // 当日划扣金额
                    if (ele.residueNumber == ele.refundContent && ele.amt) {
                        ele.refundAmt = (ele.projectAmt - ele.amt).toFixed(2)
                    } else {
                        ele.refundAmt = (ele.unitPrice * ele.refundContent).toFixed(2)
                    }
                } else if (val != 0) {
                    if (parseInt(ele.residueNumber) - parseInt(ele.refundContent) < 0) {
                        ele.refundContent = 1
                        // 剩余次数
                        ele.refundCount = parseInt(ele.residueNumber) - parseInt(ele.refundContent)
                        // 当日划扣金额
                        if (ele.residueNumber == ele.refundContent && ele.amt) {
                            ele.refundAmt = (ele.projectAmt - ele.amt).toFixed(2)
                        } else {
                            ele.refundAmt = (ele.unitPrice * ele.refundContent).toFixed(2)
                        }
                        _g.toast('warning', '已无划扣次数')
                        return;
                    } else if (parseInt(ele.residueNumber) - parseInt(ele.refundContent) >= 0) {
                        // 剩余次数
                        ele.refundCount = parseInt(ele.residueNumber) - parseInt(ele.refundContent)
                        // 当日划扣金额
                        if (ele.residueNumber == ele.refundContent && ele.amt) {
                            ele.refundAmt = (ele.projectAmt - ele.amt).toFixed(2)
                        } else {
                            ele.refundAmt = (ele.unitPrice * ele.refundContent).toFixed(2)
                        }
                    }
                }

            });
        },
        sing() {
            this.newData = this.$store.getters.productOptions;
        },
        // 划扣卡号查询提示
        cardBlur(e, index) {
            // musCodeTrue：划扣卡号是否存在 0、存在  1、不存在
            if (this.refundData[index].refundCode && this.refundData[index].refundCode != '') {
                let data = {
                    cadCode: this.refundData[index].refundCode,
                    pageSize: 1
                }
                api.requestQuiet("/skn/getClientInformation", data, (res) => {
                    if (res.result == true) {
                        if (res.data.mapList.length == 0) {
                            this.refundData[index].refundCodeTrue = 1
                            this.refundData[index].flag = true
                            this.refundData[index].musClass = 'refundCode'
                        } else {
                            this.refundData[index].flag = false
                            this.refundData[index].musClass = ''
                            this.refundData[index].refundCodeTrue = 0
                        }
                    } else {
                        this.refundData[index].refundCodeTrue = 1
                        this.refundData[index].flag = true
                        this.refundData[index].musClass = 'refundCode'
                        this.$forceUpdate()
                    }
                }, (err) => {
                });
            }
        },
        cardChange(e, index) {
            if (e == '' || !e) {
                this.refundData[index].flag = false
                this.refundData[index].musClass = ''
            }
        },
        testSX() {
            this.$forceUpdate()
        },
        // 编辑时删除部位
        del(item, listIndex) {
            var index = this.refundData.indexOf(item)
            if (index !== -1) {
                this.refundData.splice(listIndex, 1)
            }
        },
    }
}
</script>
<style scoped>
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.card >>> .el-select .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
}
.card >>> .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-input__icon {
  line-height: 30px;
}

.little >>> .el-input__inner {
  width: 180px !important;
}
.little >>> .el-input--suffix .el-input__inner {
  padding: 0px 15px !important;
}
.refundCode >>> .el-input__inner {
  border-color: #f56c6c;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.alone
  >>> .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  display: none !important;
}
.cardNum {
  color: #f56c6c;
  font-size: 12px;
}
</style>